// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__YkYW9","carouselContainer":"Layout_carouselContainer__N4wKU","textContainer":"Layout_textContainer__U7+GG"};